import { render, staticRenderFns } from "./datasource.vue?vue&type=template&id=b96daff6&scoped=true&"
import script from "./datasource.vue?vue&type=script&lang=js&"
export * from "./datasource.vue?vue&type=script&lang=js&"
import style0 from "./datasource.vue?vue&type=style&index=0&id=b96daff6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96daff6",
  null
  
)

export default component.exports